import CardDetailsInfo from './CardDetailsInfo';

export default CardDetailsInfo;
